import { ca } from '@cian/analytics';

import { ITracking } from '../../../types/tracking';

export const trackClickOfferGroupLink = (
  blockType: string[],
  page: ITracking['page'],
  products: ITracking['products'],
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Specialists',
    action: 'open_all_offers',
    label: 'company',
    page: {
      ...page,
      extra: {
        blockType,
      },
    },
    products,
  });
};
